import { PrimaryButton } from '@/core/components'
import { createStyleSheet } from '@/core/helpers'
import { useTranslation } from 'react-i18next'

interface IProps {
    next: () => void
    exit: () => void
    disabledNext: boolean
}
export const ActionFooter = ({ next, exit, disabledNext }: IProps) => {
    const { t } = useTranslation()
    return (
        <div style={styles.container}>
            <PrimaryButton
                disabled={disabledNext}
                onClick={next}
                label={t('next')}
                labelStyle={styles.btnLabel}
            />
            <PrimaryButton
                onClick={exit}
                label={t('quit')}
                style={styles.txtBtn}
                labelStyle={styles.btnLabelQuit}
            />
        </div>
    )
}

const styles = createStyleSheet({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
    },
    txtBtn: {
        backgroundColor: '#FFFFFF',
    },
    btnLabel: {
        fontSize: 14,
    },
    btnLabelQuit: {
        fontSize: 14,
        color: '#262933',
    },
})
